import { STORAGE_KEYS } from '@constants/storage';
import { TokenResponse } from '@types';

const getLocalStorageItem = (key: string) => {
  const item = localStorage.getItem(key);
  try {
    return JSON.parse(item || '');
  } catch {
    return item;
  }
};

const setLocalStorageItem = (key: string, value: unknown) => {
  localStorage.setItem(
    key,
    typeof value === 'object' ? JSON.stringify(value) : `${value}`
  );
};

const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};

const PERSIST_ACROSS_LOGOUT_KEYS = [
  STORAGE_KEYS.DISMISSED_DYNAMIC_COMPONENTS,
  STORAGE_KEYS.DYNAMIC_COMPONENT_MIXPANEL_VIEWS
];

const clearAllLocalStorageItems = () => {
  const preserved = new Map<string, string>();
  PERSIST_ACROSS_LOGOUT_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) preserved.set(key, value);
  });
  localStorage.clear();
  preserved.forEach((value, key) => localStorage.setItem(key, value));
};

const setMultipleLocalStorageItems = (
  dataItems: Array<{ key: string; value: string }>
) => {
  dataItems.forEach((item) => {
    setLocalStorageItem(item.key, item.value);
  });
};

const setTokensInStorage = ({ access_token, refresh_token }: TokenResponse) => {
  setMultipleLocalStorageItems([
    { key: STORAGE_KEYS.ACCESS_TOKEN, value: access_token },
    { key: STORAGE_KEYS.REFRESH_TOKEN, value: refresh_token }
  ]);
};

const getSessionStorageItem = (key: string) => {
  const item = sessionStorage.getItem(key);
  try {
    return JSON.parse(item || '');
  } catch {
    return item;
  }
};

const setSessionStorageItem = (key: string, value: unknown) => {
  sessionStorage.setItem(
    key,
    typeof value === 'object' ? JSON.stringify(value) : `${value}`
  );
};

const removeSessionStorageItem = (key: string) => {
  sessionStorage.removeItem(key);
};

export {
  clearAllLocalStorageItems,
  getLocalStorageItem,
  getSessionStorageItem,
  removeLocalStorageItem,
  removeSessionStorageItem,
  setLocalStorageItem,
  setMultipleLocalStorageItems,
  setSessionStorageItem,
  setTokensInStorage
};
